import { render, staticRenderFns } from "./websocket-indicator.vue?vue&type=template&id=3659e228&"
import script from "./websocket-indicator.vue?vue&type=script&lang=js&"
export * from "./websocket-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports